import { Link } from 'react-router-dom';
import { func, node, object, oneOfType, shape, string } from 'prop-types';

import NewTabOpener from '~/components/NewTabOpener';

import { PRIVACY_POLICY_APP_PATH, PRIVACY_POLICY_PATH } from '~/routes/paths';
import { getPathFromInternalLink } from '~/utils';

const LinkInternal = ({
  children,
  href,
  uri,
  className,
  to,
  style,
  onClick,
}) => {
  let link = to?.pathname || to || href || uri;
  let isInternal = false;

  if (getPathFromInternalLink(link)) {
    isInternal = true;
    link = getPathFromInternalLink(link);
    if (link === PRIVACY_POLICY_APP_PATH) {
      link = PRIVACY_POLICY_PATH;
    }
  }

  if (
    (isInternal || link.startsWith('/')) &&
    !(link.includes('/p/') || link.includes('/blog/'))
  ) {
    return (
      <Link
        className={className}
        to={{
          ...to,
          pathname: link,
        }}
        style={style ?? {}}
        onClick={onClick ?? undefined}
      >
        {children}
      </Link>
    );
  }

  return (
    <NewTabOpener
      className={className}
      href={link}
      style={style ?? {}}
      onClick={onClick ?? undefined}
    >
      {children}
    </NewTabOpener>
  );
};

LinkInternal.propTypes = {
  uri: string,
  href: string,
  children: node.isRequired,
  className: string,
  to: oneOfType([string, shape({ pathname: string })]),
  style: object,
  onClick: func,
};

LinkInternal.defaultProps = {
  href: '',
};

export default LinkInternal;
